import React, { useEffect } from 'react';
import { Button, Heading, Text, Div } from '@certilogo/design-system';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { unsetBack } from 'containers/App/actions';
import history from 'utils/history';
import styled from 'styled-components';
import ButtonComponent from 'components/ButtonComponent/web';
import messages from './messages';

const Wrapper = styled(Div)`
  margin-top: 70px;
`;

const Complete = ({
  colorType,
  authenticationId,
  data: {
    data: { token },
  },
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(unsetBack());
  }, [authenticationId]);

  const handleSubmit = () => {
    history.push(`/authentication/${authenticationId}`);
  };

  return (
    <Wrapper>
      <Heading textAlign="center" type="h1" colorType={colorType} marginBottom="m">
        <FormattedMessage {...messages.title} />
      </Heading>
      <Text textAlign="center" colorType={colorType} marginBottom="m">
        <FormattedMessage {...messages.text1} />
      </Text>
      <Text textAlign="center" colorType={colorType} marginBottom="m">
        <FormattedMessage {...messages.text2} />
      </Text>
      <ButtonComponent
        component={Button}
        colorType={colorType}
        to={`/warranty/download?token=${token}`}
        noMargin
      >
        <FormattedMessage {...messages.download} />
      </ButtonComponent>
      <Button arrow={false} buttonType="link" colorType={colorType} onClick={handleSubmit} noMargin>
        <FormattedMessage {...messages.cta} />
      </Button>
    </Wrapper>
  );
};

Complete.propTypes = {
  colorType: PropTypes.string,
  authenticationId: PropTypes.string,
  data: PropTypes.shape({
    data: PropTypes.object,
    page: PropTypes.string,
    userData: PropTypes.object,
    productData: PropTypes.object,
  }),
};

export default Complete;
